<template>
  <div>
    <ul class="mb-0 clean-list ms-tag-bag">
      <li v-for="tag in first_n_tags" :key="typeof tag === `string` ? tag : tag.name">
        <span class="multiselect__tag">{{ typeof tag === `string` ? tag : tag.name }}</span>
      </li>
    </ul>
    <template v-if="showControls">
      <b-button v-if="can_show_more"
                class="p-1"
                variant="ss-link"
                @click="showMore">
        [ Show more ]
      </b-button>
      <b-button v-if="can_show_less"
                class="p-1"
                variant="ss-link"
                @click="showLess">
        [ Show less ]
      </b-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tagsList: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    limit: {
      type: Number,
      required: false,
      default: Infinity,
    },
    showControls: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    active_limit: 0,
  }),
  computed: {
    first_n_tags() {
      return this.tagsList.slice(0, this.active_limit);
    },
    can_show_more() {
      return this.active_limit < this.tagsList.length;
    },
    can_show_less() {
      return this.active_limit > this.limit;
    },
  },
  beforeMount() {
    this.active_limit = this.limit;
  },
  methods: {
    showMore() {
      this.active_limit = this.tagsList.length;
    },
    showLess() {
      this.active_limit = this.limit;
    },
  },
};
</script>

<style lang="scss" scoped>
.ms-tag-bag {
  color: white;
  min-height: 32px;
  li {
    display: inline-block;
    .multiselect__tag {
      margin: 3px;
      padding: 4px 10px;
    }
  }
}
</style>
